import { usePermissions, useRedirect } from 'react-admin'
import { PolicyDetails as SharedPolicyDetails } from 'shared/components/Policies/PolicyDetails'

import { useTeam } from '../../helpers/useTeam'
import { ConsoleUserProvider } from '../Context/ConsoleUserProvider'

export function PolicyDetails({ match }: any) {
  const { teamId, id: policyId } = match.params
  const team = useTeam(teamId)
  const redirect = useRedirect()
  const { permissions } = usePermissions()

  if (!team) {
    return null
  }

  return (
    <ConsoleUserProvider
      isPremium={false}
      isFlexStarter={false}
      hasStarterFeature={false}
      hasFactoringFeature={false}
      permissions={permissions}
    >
      <div style={{ maxWidth: '1096px', marginTop: '30px' }}>
        <SharedPolicyDetails
          team={team}
          teamUrl={`/teams/${teamId}/show`}
          policyId={policyId}
          handlePolicyRedirect={() => redirect(`/teams/${teamId}/policy/details/${policyId}`)}
          handleRefinanceRedirect={() => redirect(`/teams/${teamId}/policy/details/${policyId}/refinance`)}
          handleTeamRedirect={() =>
            redirect(`/teams/${teamId}/policy/edit/${policyId}/`, '/teams', teamId, {}, {})
          }
        />
      </div>
    </ConsoleUserProvider>
  )
}
